var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0234 4.20996C12.4377 4.20996 12.7734 4.54575 12.7734 4.95996L12.7734 17.96C12.7734 18.3742 12.4377 18.71 12.0234 18.71C11.6092 18.71 11.2734 18.3742 11.2734 17.96L11.2734 4.95996C11.2734 4.54575 11.6092 4.20996 12.0234 4.20996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7734 20.96C19.7734 21.3742 19.4377 21.71 19.0234 21.71H5.02344C4.60922 21.71 4.27344 21.3742 4.27344 20.96C4.27344 20.5457 4.60922 20.21 5.02344 20.21H19.0234C19.4377 20.21 19.7734 20.5457 19.7734 20.96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49311 12.4296C6.786 12.1367 7.26087 12.1367 7.55377 12.4296L12.0234 16.8993L16.4931 12.4296C16.786 12.1367 17.2609 12.1367 17.5538 12.4296C17.8467 12.7225 17.8467 13.1974 17.5538 13.4903L12.5538 18.4903C12.2609 18.7832 11.786 18.7832 11.4931 18.4903L6.49311 13.4903C6.20021 13.1974 6.20021 12.7225 6.49311 12.4296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9118e99b9119c193a6f42a331d1581d7.svg";
export { ForwardRef as ReactComponent };